module.exports = __webpack_public_path__ + "img/badge_gray_hs-academic.05c29f56.svg";